import { render, staticRenderFns } from "./InsuranceRefundInvoice.vue?vue&type=template&id=64d5ff92&"
import script from "./InsuranceRefundInvoice.vue?vue&type=script&lang=js&"
export * from "./InsuranceRefundInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports